export enum FieldType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Dropdown = 'dropdown',
  Info = 'info',
  Signature = 'signature',
  CheckBox = 'checkbox',
  PresubmissionInfo = 'presubmission-info',
  phoneNumber = 'phone',
}
export enum KeyboardType {
  DEFAULT = 'default',
  NUMERIC = 'numeric',
  EMAIL = 'email-address',
  PHONE = 'phone-pad',
}
export interface DropdownMetaType {
  type: string;
  key: string;
}
export interface DropdownType {
  label: string;
  value: string;
  meta?: DropdownMetaType;
}
export enum ValidationDependencyType {
  INDEPENDENT = 'independent',
  DEPENDENT = 'dependent',
}
export interface DependentValidatorType {
  name: string;
  is: string;
  validators?: ValidatorType[];
}
export interface ValidatorType {
  type: string;
  message: string;
  value?: number | string;
}
export interface ValidationSchemaMetaType {
  maxInput?: number;
  maxDateOffset?: string;
  type: ValidationDependencyType;
  validators?: ValidatorType[];
  when?: DependentValidatorType;
}
export interface DocumentFieldMetadataType {
  dropdown?: DropdownType[];
  showOn?: string;
  dependentOrder?: string;
  validationSchema?: ValidationSchemaMetaType;
}

export interface OnboardingDocEmployeeResponseType {
  key: string;
  value: unknown;
}

export interface OnboardingDocMetadataFieldType {
  order: number;
  label: string; // shown above the field
  placeholder: string;
  type: FieldType;
  keyboardType?: KeyboardType;
  required: boolean;
  description?: string;
  prefixIcon?: string;
  suffixIcon?: string;
  metadata?: DocumentFieldMetadataType; // drop down values
  key: string; // key to be used in the form data
  value?: string;
  pdfKey?: string; // key mapping for pdf forms
  maskInput?: string;
}
export class OnboardingDocMetadataFieldDto implements OnboardingDocMetadataFieldType {
  order!: number;
  label!: string;
  placeholder!: string;
  type!: FieldType;
  keyboardType?: KeyboardType | undefined;
  required!: boolean;
  description?: string | undefined;
  prefixIcon?: string | undefined;
  suffixIcon?: string | undefined;
  metadata?: DocumentFieldMetadataType;
  key!: string;
  value?: string | undefined;
  pdfKey?: string;
}
export interface SupportingDocs {
  name: string; // i9 form/ instructions doc
  url?: string;
  description?: string;
  isTemplate: boolean;
}

export interface OnboardingDocsMetadata {
  supportingDocs?: SupportingDocs[];
  formData?: OnboardingDocMetadataFieldType[];
}

export enum DocType {
  ONBOARDING = 'ONBOARDING',
  UPLOADED = 'UPLOADED',
}
export enum DocStatus {
  PENDING = 'PENDING', // before employee submits the form, form is editable
  SUBMITTED = 'SUBMITTED', // after employee submits the form, form is uneditable
  EDIT_REQUESTED = 'EDIT_REQUESTED', // after admin rejects the form, form is editable
  APPROVED = 'APPROVED', // after admin approves the form, form is uneditable
}
